module.exports = __webpack_public_path__ + "img/khalD1.8bb245e1.png";